// Module
var code = "<svg width=\"24\" height=\"24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"11.5\" stroke=\"#3B3B3B\"/><rect x=\"6.667\" y=\"11.334\" width=\"10.667\" height=\"1.333\" rx=\".667\" fill=\"#3B3B3B\"/></svg>";
// Exports
module.exports = code;